import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { reducers } from './reducers';
import { LegalEntityEffect } from './effects/legalEntity.effect';
import { CompanyEffect } from './effects/company.effect';
import { CountryParammetersEffect } from './effects/country-parameters.effect';
import { CoreService } from './services/core.service';
import { ParametersService } from './services/parameters.service';
import { StorageManagerService } from './services/storage-manager.service';

@NgModule({
    imports: [
        StoreModule.forFeature('core', reducers),
        EffectsModule.forFeature([
            LegalEntityEffect,
            CompanyEffect,
            CountryParammetersEffect
        ]),
    ],
    providers: [
        CoreService,
        ParametersService,
        StorageManagerService
    ]
})
export class CoreModule {
    constructor() {}
}
